import React from 'react';
import { Text } from 'library';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { styled } from '@mui/material';
import { SectionContainer } from './SectionContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Colors from 'constants/Colors';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';

export default function RequestedWorkersSection() {
    const { form } = useJobFormContext();
    const { preferredWorkers } = form.fieldStates;
    return (
        <SectionContainer>
            <Text variant="h2" bold textStyle={styles.header}>
                Requested Workers
            </Text>
            {preferredWorkers.value.map((worker) => (
                <WorkerContainer key={worker.id}>
                    <FontAwesomeIcon icon={faSquareCheck} color={Colors.turquoise} />
                    <Text variant="body2">{worker.name}</Text>
                </WorkerContainer>
            ))}
        </SectionContainer>
    );
}

const styles = {
    header: {
        marginBottom: 8,
    },
};

const WorkerContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
});
